// import Swiper from 'swiper/swiper-bundle';

export function mv() {
    const mvSlides = document.querySelectorAll('.p-mv_imgs li');

    if (mvSlides.length > 0) {
    let currentIndex = 0;

    // 最初の画像を表示
    mvSlides[currentIndex].classList.add('is-active');

    // 4秒ごとに切り替え
    setInterval(() => {
        mvSlides[currentIndex].classList.remove('is-active');

        currentIndex++;

        if (currentIndex >= mvSlides.length) {
        currentIndex = 0;
        }

        mvSlides[currentIndex].classList.add('is-active');
    }, 4000);
    }

}